import React from 'react'

import { useDynamicManageStore } from 'store/useDynamicManageStore'

import Header from 'components/Headers/Header'

import { docUploadAnalytics } from 'analytics/docUploadAnalytics'

const DocUploadHeader = () => {
    const { onBack } = useDynamicManageStore((state) => state)

    const handleBack = () => {
        docUploadAnalytics.track('backToDM')
        onBack()
    }
    return <Header handleBack={handleBack} />
}

export default DocUploadHeader
